export default __webpack_public_path__ + "static/media/spookytropicsresort_demo_image.14d25f6c.png";